/** Development flags and lightweight logging helpers. */
export const Debug = {
  /** Overlay visibility. */
  showOverlay: false,
  /** Draw surface normals and edge markers. */
  showSurfaces: false,
  /** Slow the simulation down to inspect transitions. */
  slowMotion: false,
  /** Allow flying without a surface (skips attachment). */
  noclip: false,
  log: false,
};

export function logInfo(message: string): void {
  if (!Debug.log) return;
  // eslint-disable-next-line no-console
  console.info(`[magnetic-hound] ${message}`);
}

export function logWarn(message: string, error?: unknown): void {
  console.warn(`[magnetic-hound] ${message}`, error ?? '');
}

export function logError(message: string, error?: unknown): void {
  console.error(`[magnetic-hound] ${message}`, error ?? '');
}
